import type { CSSProperties, ReactElement } from 'react';

import { ReactComponent as Info } from 'Components/UI_Library/Icons/Info.svg';
import classes from './Tooltip.module.css';

type Props = {
    hoverText: string;
    showIcon?: boolean;
    children?: ReactElement;
    disabled?: boolean;
    alwaysShow?: boolean;
    onTop?: boolean;
    marginLeft?: CSSProperties['marginLeft'];
    /**
     * Delay showing the tooltip until the user has hovered over the element for a short time.
     * @default false */
    delay?: boolean;
};

const Tooltip = (props: Props) => (
    <div
        style={{
            ...(props.marginLeft && { marginLeft: props.marginLeft }),
        }}
        className={classes.tooltip}
    >
        {props.children}
        {props.showIcon ? <Info className={classes.icon} /> : null}

        {props.disabled ? null : (
            <div
                className={`${classes.tooltipText} ${props.alwaysShow ? classes.alwaysVisible : ''} ${
                    props.onTop ? classes.onTop : ''
                } ${props.delay ? classes.delayed : ''}`}
            >
                {props.hoverText}
            </div>
        )}
    </div>
);

export default Tooltip;
